var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.formLocked)?_c('v-alert',{attrs:{"border":"left","color":"primary","type":"info","outlined":""}},[_c('span',{staticClass:"text-sm-body-2"},[_vm._v(_vm._s(this.lockedMessage)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }